import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ClearLocalStorageByPath() {
  let location = useLocation();
  useEffect(() => {
    if (location.pathname !== '/resetPassword') {
      localStorage.removeItem('rp');
    }
    if (location.pathname !== '/editDriver') {
      localStorage.removeItem('selectedDriver');
    }
    if (location.pathname !== '/editCar') {
      localStorage.removeItem('selectedCar');
    }
    if (location.pathname !== '/editProfile') {
      localStorage.removeItem('selectedProfile');
    }
    if (
      location.pathname !== '/editCharger' &&
      location.pathname !== '/selectConnector' &&
      location.pathname !== '/favChargers' &&
      location.pathname !== '/history' &&
      location.pathname !== '/profiles' &&
      location.pathname !== '/addProfile' &&
      location.pathname !== '/editProfile'
    ) {
      // localStorage.removeItem('selectedCharger');
    }
    if (location.pathname !== '/selectConnector') {
        localStorage.removeItem('selectedConnector');
        localStorage.removeItem('smartData');
        localStorage.removeItem('localCharging');
      }

    if (location.pathname !== '/editGroup') {
      localStorage.removeItem('selectedGroup');
    }
  }, [location.pathname]);
}
